<div class="toggle-all-row" *ngIf="showToggleAll && groupedIssues.length > 0">
  <button class="toggle-all-btn" (click)="toggleAll()">
    {{ allExpanded ? 'Collapse All' : 'Expand All' }}
  </button>
</div>
<div class="issue-group" *ngFor="let group of groupedIssues; trackBy: trackByGroup">
  <!-- Single-issue group: render issue directly, no parent accordion -->
  <ng-container *ngIf="group.issues.length === 1; else multiIssueGroup">
    <issue [issue]="group.issues[0]" [sync-pair]="syncPair" [application]="application" [grouped]="false"></issue>
  </ng-container>

  <!-- Multi-issue group: parent accordion with children -->
  <ng-template #multiIssueGroup>
    <button class="group-header" (click)="toggleGroup(group)" [class.expanded]="group.expanded">
      <div class="group-title">
        <span class="group-name">{{ group.issueType }}</span>
        <span class="group-count">{{ group.issues.length }}</span>
      </div>
      <div class="group-chevron">
        <i
          class="fa-utility fa-semibold"
          [ngClass]="{ 'fa-angle-down': !group.expanded, 'fa-angle-up': group.expanded }"
        ></i>
      </div>
    </button>
    <div class="group-body" [@accordionSlide]="group.expanded ? 'expanded' : 'collapsed'">
      <issue
        *ngFor="let issue of group.issues; trackBy: trackByFn"
        [issue]="issue"
        [sync-pair]="syncPair"
        [application]="application"
        [grouped]="true"
      ></issue>
    </div>
  </ng-template>
</div>
